import clx from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

const StyledIconColor = styled.span`
  font-size: 16px;
  line-height: 1;
  &.success {
    color: ${props => props.theme.colorSuccess};
  }
  &.error {
    color: ${props => props.theme.colorError};
  }
  &.warning {
    color: ${props => props.theme.colorWarning};
  }
  &.info {
    color: ${props => props.theme.colorInfo};
  }
  &.primary {
    color: ${props => props.theme.colorPrimary};
  }
  &.secondary {
    color: ${props => props.theme.colorTextSecondary};
  }
  &.tertiary {
    color: ${props => props.theme.colorBorder};
  }
  &.disabled {
    color: ${props => props.theme.colorTextDisabled};
  }
`;

export interface IconColorProps extends React.HTMLAttributes<HTMLSpanElement> {
  type?:
    | 'success'
    | 'error'
    | 'warning'
    | 'info'
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'disabled';
}
/**
 * Wrapper che permette di colorare un'icona con i colori del thema applicativo
 */
export function IconColor(props: IconColorProps) {
  return (
    <StyledIconColor {...props} className={clx(props.className, props.type)} />
  );
}
